module.exports = __webpack_public_path__ + "img/haft-poznan-09.3882ac81.jpg";